document.addEventListener("DOMContentLoaded", function(event) {

    if(typeof gform  !== "undefined"){
        gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
            // Apply to field 2 only 
            //if ( fieldId == 2 ) 
            //{
                optionsObj.minDate = '-365';
                optionsObj.maxDate = 0;
            //}
            return optionsObj;
        });
    }
});